import { addDoc, collection, doc, getDocs, limit, query, QueryDocumentSnapshot, setDoc, SnapshotOptions, where, WithFieldValue } from "firebase/firestore";
import { db } from "../firebase";
import { firebaseDataConverter } from "./Converters/FirebaseConverter";
import { User, UserFromDbMapper, UserToDbMapper } from "../models/User";
import { UserDb } from "./models/UserDb";
import { v4 as uuidv4 } from 'uuid';

class UserService {
    private static instance: UserService | null = null;

    private static tableName: string = "user";
    public static getInstance(): UserService {
        if (this.instance === null) {
            this.instance = new UserService();
        }
        return this.instance;
    }

    public async getProductKeysAsync(): Promise<User[]> {
        const documents = await getDocs(query(collection(db, UserService.tableName)).withConverter<UserDb>(firebaseDataConverter))
        const mapped = documents.docs.map(doc => {
            var data = doc.data()
            return UserFromDbMapper(data);
        });
        return mapped;
    }

    public async getUserByGuidAsync(guid: string): Promise<User | null> {
        const q = query(collection(db, UserService.tableName),
            where("guid", "==", guid),
            limit(1)).withConverter<UserDb>(firebaseDataConverter);
        const documents = await getDocs(q)
        if (documents.docs.length < 1) return null;
        return UserFromDbMapper(documents.docs[0].data());
    }

    public async addProductKeyAsync(company: User): Promise<void> {
        var mappedDb = UserToDbMapper(company);
        await setDoc(doc(db, UserService.tableName, uuidv4()).withConverter<UserDb>(firebaseDataConverter), mappedDb);
    }
}

const useUserService = () => {
    return UserService.getInstance();
}

export default useUserService;

